import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex-grow flex flex-col space-y-3" }
const _hoisted_2 = { class: "flex flex-col space-y-3 p-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "text-red-800 font-medium" }, "Not a contract", -1)
const _hoisted_4 = { class: "text-red-700" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "font-medium text-lg" }, "Standard Interfaces", -1)
const _hoisted_6 = { class: "flex flex-col mx-3" }
const _hoisted_7 = { class: "space-y-2 mt-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "font-medium text-lg" }, "Contract Methods", -1)
const _hoisted_9 = { class: "flex flex-col gap-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "text-red-800 font-medium" }, "Transaction Execution Error", -1)
const _hoisted_11 = { class: "text-red-700" }
const _hoisted_12 = { class: "mt-2 text-red-700 bg-gray-400 bg-opacity-10 p-2 border border-gray-300 rounded-sm font-mono whitespace-nowrap max-w-sm overflow-x-auto custom-scrollbar" }
const _hoisted_13 = {
  key: 1,
  class: "inline-flex items-center gap-2 font-medium mb-1"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Successful", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XCircleIcon = _resolveComponent("XCircleIcon")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Method = _resolveComponent("Method")!
  const _component_DashboardCard = _resolveComponent("DashboardCard")!
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_TransactionResult = _resolveComponent("TransactionResult")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createVNode(_component_DashboardCard, { title: "Contract Interactions" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (!_ctx.accountIsContract)
              ? (_openBlock(), _createBlock(_component_Alert, {
                  key: 0,
                  class: "bg-red-50"
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_XCircleIcon, {
                      class: "w-5 h-5 text-red-600",
                      "aria-hidden": "true"
                    })
                  ]),
                  default: _withCtx(() => [
                    _hoisted_3,
                    _createElementVNode("p", _hoisted_4, " The account " + _toDisplayString(_ctx.account) + " does not have a contract deployed. ", 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.contract.probableInterfaces.length > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_5,
                        _createElementVNode("ul", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contract.probableInterfaces, (interfaceId) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: interfaceId,
                              class: "m-1 px-4 py-2 font-medium rounded-sm border-l-4",
                              style: _normalizeStyle({
                  'border-color': _ctx.getDeterministicHueColor(
                    interfaceId,
                    100,
                    40,
                  ),
                })
                            }, [
                              _createElementVNode("div", null, _toDisplayString(_ctx.interfaces[interfaceId].name), 1),
                              _createElementVNode("div", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interfaces[interfaceId].methods, (method) => {
                                  return (_openBlock(), _createBlock(_component_Method, {
                                    key: method.name,
                                    methodName: method.name,
                                    suggestedArguments: method.args,
                                    label: _ctx.interfaces[interfaceId].name
                                  }, null, 8, ["methodName", "suggestedArguments", "label"]))
                                }), 128))
                              ])
                            ], 4))
                          }), 128))
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contract.methodNames, (methodName) => {
                      return (_openBlock(), _createBlock(_component_Method, {
                        key: methodName,
                        methodName: methodName
                      }, null, 8, ["methodName"]))
                    }), 128))
                  ])
                ], 64))
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Modal, {
      open: _ctx.isTransactionResultsModalOpen,
      onClose: _ctx.closeTransactionResultsModal,
      title: "Transaction Results"
    }, {
      default: _withCtx(() => [
        (_ctx.errorCode)
          ? (_openBlock(), _createBlock(_component_Alert, {
              key: 0,
              class: "bg-red-50"
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_XCircleIcon, {
                  class: "w-5 h-5 text-red-600",
                  "aria-hidden": "true"
                })
              ]),
              default: _withCtx(() => [
                _hoisted_10,
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.errorCode), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.errorMessage), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.transactionHashes.length > 0)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_CheckCircleIcon, {
                class: "w-5 h-5 text-green-600",
                "aria-hidden": "true"
              })
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactionHashes, (hash) => {
          return (_openBlock(), _createBlock(_component_TransactionResult, {
            key: hash,
            hash: hash
          }, null, 8, ["hash"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["open", "onClose"])
  ], 64))
}